module.exports = "<a ng-if=\"$ctrl.value !== 'No Tracking Number'\"\r\n   ng-href=\"{{$ctrl.getShippingPartnerLink($ctrl.value)}}\"\r\n   target=\"_blank\">\r\n  {{ $ctrl.value }}\r\n</a>\r\n<span ng-if=\"$ctrl.value === 'No Tracking Number'\">\r\n  <translate>No Tracking Number</translate>\r\n</span>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/rw-tracking-number/rw-tracking-number.html
// module id = 1967
// module chunks = 0